<template>
  <div class="ms-grid-pager">
    <el-button
      class="btn"
      title="Primera"
      @click.prevent="first"
    >
      <i class="grid-icon-chevrons-left"/>
    </el-button>
    <el-button
      class="btn"
      title="Anterior"
      @click.prevent="prev"
    >
      <i class="grid-icon-chevron-left"/>
    </el-button>
    <span> Página </span>
    <form @submit.prevent="changePage">
      <input
        v-model="currentPage"
        class="input-pager"
        type="text"
        @input="onInput"
        @focus="onFocus"
      >
    </form>
    <span> de {{ lastPage }} </span>
    <el-button
      class="btn"
      title="Siguiente"
      @click.prevent="next"
    >
      <i class="grid-icon-chevron-right"/>
    </el-button>
    <el-button
      class="btn"
      title="Última"
      @click.prevent="last"
    >
      <i class="grid-icon-chevrons-right"/>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'MsGridPager',
  props: {
    page: {
      type: [Number, String],
      default: null
    },
    lastPage: {
      type: [Number, String],
      default: null
    },
    total: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      currentPage: 1,
      waitTime: 1000,
      timeOut: null
    }
  },
  mounted () {
    this.currentPage = parseInt(this.page)
    document.addEventListener('keyup', this.onKeyUp)
  },
  methods: {
    onFocus (e) {
      e.target.select()
    },
    onKeyUp (e) {
      switch (e.keyCode) {
        case 37:
          this.prev()
          break
        case 39:
          this.next()
          break
      }
    },
    first () {
      if (this.currentPage > 1) {
        this.currentPage = 1
        this.changePage()
      }
    },
    last () {
      if (this.currentPage < this.lastPage) {
        this.currentPage = parseInt(this.lastPage)
        this.changePage()
      }
    },
    next () {
      if (this.currentPage < this.lastPage) {
        this.currentPage++
        this.changePage()
      }
    },
    prev () {
      if (this.currentPage > 1) {
        this.currentPage--
        this.changePage()
      }
    },
    changePage () {
      clearTimeout(this.timeOut)
      this.$emit('changePage', this.currentPage)
    },
    onInput (e) {
      if (e.target.value > this.lastPage) {
        this.currentPage = this.lastPage
      } else if (e.target.value < 1) {
        this.currentPage = 1
      } else {
        this.currentPage = e.target.value
      }
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(this.changePage, this.waitTime)
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
  @import url(./assets/style.css);

  .ms-grid-pager {
    padding-top: 20px;
    text-align: right;
    padding-right: 23px;
    form {
      display: inline-block;
      input {
        width: 40px;
        height: 40px;
        text-align: center;
      }
    }
    .input-pager {
      width: 41px;
      height: 41px;
      box-shadow: none;
      border: solid 1px #D7DAE2;
      padding-top: 4px;
    }
    .el-button {
      margin-left: 0px;
      padding: 12px;
    }
    .btn {
      background-color: #fff;
      border-radius: 0;
      &:first-child {
        border-radius: 2px 0 0 2px;
      }
      &:last-child {
        border-radius: 0 2px 2px 0;
      }
      &:active {
        box-shadow: none;
        outline: 0;
      }
    }
    span {
      margin: 0px 3px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/modules/grid/ms-grid-pager.vue